import ReactGA from "react-ga4";
import { GoogleAnalyticalSubmissionEventDto } from "../Interface/dtos";

class GoogleAnalyticService {
  private googleAnalyticMeasurementId: string;
  constructor() {
    this.googleAnalyticMeasurementId =
      process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID || "";
    ReactGA.initialize(this.googleAnalyticMeasurementId);
  }

  handleSubmissionEvents(data: GoogleAnalyticalSubmissionEventDto) {
    const { category, action, label } = data;
    try {
      ReactGA.event({
        category,
        action,
        label,
      });
    } catch (error: any) {
      console.error(
        "GoogleAnalyticService -> handleSubmissionEvents -> error",
        error
      );
    }
  }
}

const googleAnalyticService = new GoogleAnalyticService();
export default googleAnalyticService;
